export const worldEs = {
  'world.seo.title': 'El Mundo',
  'world.seo.description':
    'Explora los mapas interactivos de Grymwyrd — sus reinos, ruinas y los escenarios de la leyenda, en cartografía 2D y un globo terráqueo rotable en 3D.',
  'world.heading': 'El Mundo',
  'world.intro':
    'Traza el crepúsculo eterno. El atlas está diseñado para una visión anidada — amplía desde el mundo entero hasta una mazmorra individual. Por ahora, solo el nivel superior es interactivo; los niveles más profundos se abrirán conforme se mapeen los reinos.',

  'world.viewMode.label': 'Modo de vista del mapa',
  'world.viewMode.map2d': 'Mapa 2D',
  'world.viewMode.globe3d': 'Globo 3D',

  'world.gazetteer.navLabel': 'Localizaciones y escenas',
  'world.gazetteer.heading': 'Nomenclátor',
  'world.gazetteer.sampleNotice':
    'Se muestran lugares de ejemplo — el verdadero levantamiento del cartógrafo aún no ha sido registrado.',
  'world.gazetteer.error': 'No se pudo acceder al archivo del atlas.',

  'world.loading.atlas': 'Desenrollando el atlas…',
  'world.loading.globe': 'Girando el mundo…',

  'world.layersActive': '{active} de {total} capas activas.',
  'world.globeHint':
    'Arrastra para rotar (la rotación automática se pausa mientras exploras, reanudándose tras un minuto de inactividad); desplázate para ampliar. Pasa el ratón sobre un hexágono para revelar su campaña, haz clic para entrar.',
  'world.webglUnavailable':
    'El globo 3D necesita WebGL, que no está disponible aquí — mostrando el atlas 2D en su lugar.',

  'world.campaign.capitalRegion': 'Región Capital',
  'world.campaign.territory': 'Territorio de la Campaña',
  'world.campaign.enter': 'Entrar en Campaña',
  'world.campaign.stay': 'Permanecer en Órbita',

  'world.layers.heading': 'Capas del Mapa',
  'world.layers.gmBadge': 'DJ',
  'world.layers.gmRequired': 'Requiere el rol de Director de Juego.',

  'world.marker.sampleBadge': 'Datos de ejemplo',
  'world.marker.viewInEncyclopedia': 'Ver en la Enciclopedia',
  'world.marker.placeholderNote':
    'Este es un sitio marcador de posición — una vez que se escriba su trasfondo se vinculará a la Enciclopedia.',

  'world.map2d.ariaLabel': 'Mapa interactivo del mundo exterior',
  'world.map2d.noOverworld': 'La cartografía del mundo exterior aún no ha sido inscrita — mostrando el vacío',

  'world.globe.hint.enter': 'Entrar ▸',
  'world.globe.hint.open': 'Abrir ▸',
  'world.globe.hint.claim': 'Reclamar ▸',
  'world.globe.uncharted': 'Alcances Inexplorados',
  'world.globe.unchartedBlurb':
    'Ninguna campaña ha reclamado este hexágono del crepúsculo eterno. Planta el primer estandarte.',
  'world.globe.capitalLabel': 'Grymwyrd',
} as const
